import { Injectable } from '@angular/core';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../../shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Country } from '../../models/common-data/country';
import { State } from '../../models/common-data/state';
import { CommonDataHttpServiceInterface } from './common-data.http-service.interface';
import { Currency } from '../../models/common-data/currency';

@Injectable()
export class CommonDataHttpService implements CommonDataHttpServiceInterface {

  private baseUrl = this.environment.onyxCommonDataUrl;
  private countryEndpoint = '/v1/country';
  private currencyEndpoint = '/v1/currency/transaction';
  private stateEndpoint = '/state';

  constructor(private http: HttpClient,
    private environment: EnvironmentConfiguration,
    private responseUtilService: ResponseUtilService) {
  }

  getCountries(): Observable<Country[] | Response> {
    return this.http.get<Country[]>(`${this.baseUrl}${this.countryEndpoint}`)
      .catch(error => this.responseUtilService.handleError(error))
      .share();
  }

  getCurrencies(): Observable<Currency[] | Response> {
    return this.http.get<Currency[]>(`${this.baseUrl}${this.currencyEndpoint}`)
      .catch(error => this.responseUtilService.handleError(error))
      .share();
  }

  getStates(countryCode: string): Observable<State[] | Response> {
    return this.http.get<State[]>(`${this.baseUrl}${this.countryEndpoint}/${countryCode}${this.stateEndpoint}`)
      .catch(error => this.responseUtilService.handleError(error))
      .share();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/common-data/common-data.http-service.ts